export interface Product {
  id: string;
  name: string;
  tagline: string;
  price: number;
  description: string;
  features: string[];
  specs: Record<string, string>;
  imageUrl: string;
}
 
export enum AgentState {
  DISCONNECTED = 'DISCONNECTED',
  CONNECTING = 'CONNECTING',
  CONNECTED = 'CONNECTED',
  ERROR = 'ERROR',
}

export interface SalesAgentContextType {
  state: AgentState;
  connect: () => Promise<void>;
  disconnect: () => Promise<void>;
  isSpeaking: boolean; // Is the AI speaking?
  userVolume: number; // For visualizer
  aiVolume: number; // For visualizer
  error: string | null;
}

export interface StoreState {
  selectedColor: string;
  cartCount: number;
  isCheckedOut: boolean;
}

export interface StoreContextType extends StoreState {
  setColor: (color: string) => void;
  addToCart: () => void;
  checkout: () => void;
}


export enum AppState {
  IDLE = 'IDLE',
  ANALYZING = 'ANALYZING',
  EDITING = 'EDITING',
  PUBLISHING = 'publishing',
  PUBLISHED = 'PUBLISHED',
}

export interface ProductData {
  title: string;
  description: string;
  price: number;
  currency: string;
  category: string;
  tags: string[];
  images: string[];
  fileSize: number;
  fileType: string;

  // Attributes
  colors: string[];
  sizes: string[];
  materials: string[];
  styles: string[];
  patterns: string[];

  // Details
  brand: string;
  condition: 'New' | 'Used' | 'Refurbished';
  isDigital: boolean;
  
  // Digital Product Fields
  digitalProductLink?: string;
  digitalFileName?: string;
  digitalFileSize?: number;
  digitalFileType?: string;
  cloudinaryPublicId?: string;
  allowedDownloads?: number;
  downloadExpiryDays?: number;
  watermarkEnabled?: boolean;
  digitalProductType?: 'ebook' | 'art_collection' | 'other';
  
  // Inventory & Stock
  stock: number;
  sku?: string;
  inventory?: number;

  // Logistics
  dimensions: string;
  weight: string;
  deliveryOption: string;
  deliveryTimeline: string;
  returnPolicy: string;

  // Negotiation & Pricing
  acceptNegotiations?: boolean;
  minPrice?: number;
  maxPrice?: number;
  
  // Delivery Options
  availableForPickup?: boolean;
  availableForDelivery?: boolean;
  lagosDeliveryFee?: number;
  outsideLagosDeliveryFee?: number;
  
  // Service-specific fields
  upfrontPaymentPercentage?: number;
  
  // Listing Type
  listingType?: 'product' | 'service';
  
  // Specific SKU Variants
  variants: ProductVariant[];
}

export interface ProductVariant {
  id: string;
  name: string;
  price: number;
  stock: number;
  attributes: Record<string, string>;
  sku?: string;
}

export interface AnalysisResult {
  product: ProductData;
}